import React, {PropsWithChildren, ReactElement, useEffect, useRef, useState} from "react";
import {FacebookShareButton, TwitterShareButton, WhatsappShareButton} from "react-share";
import {css} from "@emotion/react";

import {borderRadius, calculateRemSize, flex, flexAbsoluteCenter, flexDirection, mr, p, pointer} from "@pg-design/helpers-css";
import {FacebookFlatIcon, UrlIcon, WhatsAppIcon, XBigIcon} from "@pg-design/icons";
import {Text} from "@pg-design/text";
import {replaceSpaceWithNonBreakingSpace} from "@pg-mono/string-utils";

import {SocialShareCloseIconButton} from "./SocialShareCloseIconButton";

interface IProps extends PropsWithChildren {
    title: string;
    url: string;
    disableNativeShare?: boolean;
    shareDropdownWidth?: string;
    onError?: (error: Error) => void;
    onTracking?: () => void;
}

export const SocialShare = (props: IProps) => {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const {title, url} = props;
    const [isDropdownOpened, setIsDropdownOpened] = useState(false);

    useEffect(() => {
        if (wrapperRef.current && isDropdownOpened) {
            const handleOutsideClick = (event: MouseEvent) => {
                if (!wrapperRef.current?.contains(event.target as HTMLElement)) {
                    setIsDropdownOpened(false);
                }
            };
            window.document.addEventListener("click", handleOutsideClick);

            return () => {
                window.document.removeEventListener("click", handleOutsideClick);
            };
        }
    }, [wrapperRef.current, isDropdownOpened]);

    const handleOnClick = async () => {
        const shareData = {
            title,
            url
        };

        if (isNativeShareSupported() && navigator.canShare(shareData)) {
            await nativeShare(shareData);
        } else {
            setIsDropdownOpened((prev) => !prev);
        }
    };

    const isNativeShareSupported = () => {
        return "share" in navigator && !props.disableNativeShare;
    };

    const nativeShare = async (shareData: {title: string; url: string}) => {
        try {
            await navigator.share(shareData);
        } catch (error) {
            props.onError?.(new Error(`Problem with native share: ${error}`));
        }
    };

    const onLinkCopyClick = () => {
        try {
            props?.onTracking?.();
            onClose();
            navigator.clipboard.writeText(url);
        } catch (error) {
            props.onError?.(new Error(`Problem with link copy to clipboard: ${error}`));
        }
    };

    const createShareDropdownItem = (iconSlot: ReactElement, text: string) => (
        <div css={[flex("center"), flexDirection("row"), pointer]}>
            <div css={shareDropdownItemIconStyle}>{iconSlot}</div>
            <Text variant="info_txt_1">{text}</Text>
        </div>
    );

    const onClose = () => {
        setIsDropdownOpened(false);
    };

    const onShareClick = () => {
        props?.onTracking?.();
        onClose();
    };

    return (
        <div ref={wrapperRef} css={wrapperStyle}>
            <div onClick={handleOnClick}>{props.children}</div>
            {isDropdownOpened && (
                <div css={shareDropdownStyle} style={props.shareDropdownWidth ? {width: props.shareDropdownWidth} : undefined}>
                    <SocialShareCloseIconButton onClick={onClose} size="1.6" top={0.5} right={1} />
                    <FacebookShareButton onClick={onShareClick} url={url}>
                        {createShareDropdownItem(<FacebookFlatIcon size="2.4" />, `udostępnij ${replaceSpaceWithNonBreakingSpace("na Facebook")}`)}
                    </FacebookShareButton>
                    <TwitterShareButton onClick={onShareClick} url={url} title={title}>
                        {createShareDropdownItem(<XBigIcon size="2.4" />, `udostępnij ${replaceSpaceWithNonBreakingSpace("na X")}`)}
                    </TwitterShareButton>
                    <WhatsappShareButton onClick={onShareClick} title={title} url={url}>
                        {createShareDropdownItem(<WhatsAppIcon size="2.4" />, `udostępnij ${replaceSpaceWithNonBreakingSpace("na WhatsApp")}`)}
                    </WhatsappShareButton>
                    <div onClick={onLinkCopyClick}>{createShareDropdownItem(<UrlIcon size="2.4" />, "skopiuj link")}</div>
                </div>
            )}
        </div>
    );
};

const wrapperStyle = css`
    position: relative;
`;

const shareDropdownStyle = css`
    ${p(2)};
    position: absolute;
    bottom: calc(100% + ${calculateRemSize(2)});
    right: 0;
    width: min(30rem, 100vw);
    z-index: 4;
    ${flex()};
    flex-direction: column;
    gap: ${calculateRemSize(2)};
    ${borderRadius(1)};
    background-color: #fff;
`;

const shareDropdownItemIconStyle = css`
    flex: 0 0 auto;
    ${flexAbsoluteCenter};
    width: ${calculateRemSize(3)};
    height: ${calculateRemSize(3)};
    ${mr(1)};
`;
import React, {PropsWithChildren, ReactElement, useEffect, useRef, useState} from "react";
import {FacebookShareButton, TwitterShareButton, WhatsappShareButton} from "react-share";
import {css} from "@emotion/react";

import {borderRadius, calculateRemSize, flex, flexAbsoluteCenter, flexDirection, mr, p, pointer} from "@pg-design/helpers-css";
import {FacebookFlatIcon, UrlIcon, WhatsAppIcon, XBigIcon} from "@pg-design/icons";
import {Text} from "@pg-design/text";
import {replaceSpaceWithNonBreakingSpace} from "@pg-mono/string-utils";

import {SocialShareCloseIconButton} from "./SocialShareCloseIconButton";

interface IProps extends PropsWithChildren {
    title: string;
    url: string;
    disableNativeShare?: boolean;
    shareDropdownWidth?: string;
    onError?: (error: Error) => void;
    onTracking?: () => void;
}

export const SocialShare = (props: IProps) => {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const {title, url} = props;
    const [isDropdownOpened, setIsDropdownOpened] = useState(false);

    useEffect(() => {
        if (wrapperRef.current && isDropdownOpened) {
            const handleOutsideClick = (event: MouseEvent) => {
                if (!wrapperRef.current?.contains(event.target as HTMLElement)) {
                    setIsDropdownOpened(false);
                }
            };
            window.document.addEventListener("click", handleOutsideClick);

            return () => {
                window.document.removeEventListener("click", handleOutsideClick);
            };
        }
    }, [wrapperRef.current, isDropdownOpened]);

    const handleOnClick = async () => {
        const shareData = {
            title,
            url
        };

        if (isNativeShareSupported() && navigator.canShare(shareData)) {
            await nativeShare(shareData);
        } else {
            setIsDropdownOpened((prev) => !prev);
        }
    };

    const isNativeShareSupported = () => {
        return "share" in navigator && !props.disableNativeShare;
    };

    const nativeShare = async (shareData: {title: string; url: string}) => {
        try {
            await navigator.share(shareData);
        } catch (error) {
            props.onError?.(new Error(`Problem with native share: ${error}`));
        }
    };

    const onLinkCopyClick = () => {
        try {
            props?.onTracking?.();
            onClose();
            navigator.clipboard.writeText(url);
        } catch (error) {
            props.onError?.(new Error(`Problem with link copy to clipboard: ${error}`));
        }
    };

    const createShareDropdownItem = (iconSlot: ReactElement, text: string) => (
        <div css={[flex("center"), flexDirection("row"), pointer]}>
            <div css={shareDropdownItemIconStyle}>{iconSlot}</div>
            <Text variant="info_txt_1">{text}</Text>
        </div>
    );

    const onClose = () => {
        setIsDropdownOpened(false);
    };

    const onShareClick = () => {
        props?.onTracking?.();
        onClose();
    };

    return (
        <div ref={wrapperRef} css={wrapperStyle}>
            <div onClick={handleOnClick}>{props.children}</div>
            {isDropdownOpened && (
                <div css={shareDropdownStyle} style={props.shareDropdownWidth ? {width: props.shareDropdownWidth} : undefined}>
                    <SocialShareCloseIconButton onClick={onClose} size="1.6" top={0.5} right={1} />
                    <FacebookShareButton onClick={onShareClick} url={url}>
                        {createShareDropdownItem(<FacebookFlatIcon size="2.4" />, `udostępnij ${replaceSpaceWithNonBreakingSpace("na Facebook")}`)}
                    </FacebookShareButton>
                    <TwitterShareButton onClick={onShareClick} url={url} title={title}>
                        {createShareDropdownItem(<XBigIcon size="2.4" />, `udostępnij ${replaceSpaceWithNonBreakingSpace("na X")}`)}
                    </TwitterShareButton>
                    <WhatsappShareButton onClick={onShareClick} title={title} url={url}>
                        {createShareDropdownItem(<WhatsAppIcon size="2.4" />, `udostępnij ${replaceSpaceWithNonBreakingSpace("na WhatsApp")}`)}
                    </WhatsappShareButton>
                    <div onClick={onLinkCopyClick}>{createShareDropdownItem(<UrlIcon size="2.4" />, "skopiuj link")}</div>
                </div>
            )}
        </div>
    );
};

const wrapperStyle = css`
    position: relative;
`;

const shareDropdownStyle = css`
    ${p(2)};
    position: absolute;
    bottom: calc(100% + ${calculateRemSize(2)});
    right: 0;
    width: min(30rem, 100vw);
    z-index: 4;
    ${flex()};
    flex-direction: column;
    gap: ${calculateRemSize(2)};
    ${borderRadius(1)};
    background-color: #fff;
`;

const shareDropdownItemIconStyle = css`
    flex: 0 0 auto;
    ${flexAbsoluteCenter};
    width: ${calculateRemSize(3)};
    height: ${calculateRemSize(3)};
    ${mr(1)};
`;
